<template>
    <div
        class="grid grid-cols-12 flex-1 items-center gap-2 px-3 py-2 rounded-lg mb-6 relative sm:gap-4 sm:pl-5 sm:pr-4 sm:py-3"
        :class="{
            'bg-white dark:bg-slate-800':
                redemption.date_type === 'start' &&
                redemption.status !== 'cancelled',
            'bg-slate-50 dark:bg-slate-900/40':
                redemption.date_type === 'end' &&
                redemption.status !== 'cancelled',
            'bg-red-50 border border-red-200':
                redemption.status === 'cancelled',
        }"
    >
        <!-- content card -->
        <div
            class="col-span-12 sm:col-span-6 flex flex-col sm:flex-col sm:items-start pr-8 sm:pr-0"
        >
            <a
                href="#"
                role="button"
                :class="
                    redemption.status === 'cancelled'
                        ? 'text-slate-400 text-sm font-medium line-through'
                        : 'text-slate-800 dark:text-slate-100 text-sm font-medium'
                "
                v-if="
                    redemption.date_type === 'start' &&
                    (redemption.redemption_type.slug === 'hotel' ||
                        redemption.redemption_type.slug === 'other')
                "
                @click.prevent="emit('viewRedemption', redemption)"
            >
                {{ endLabel }} {{ redemption.name || '' }}
                <span
                    v-if="redemption.source === 'email_import'"
                    class="inline-flex align-text-bottom ml-1"
                >
                    <Icon
                        icon="email-forward"
                        :width="20"
                        :height="20"
                        class="text-[#64748B] dark:text-slate-400"
                        pathClass="fill-[#64748B]"
                    />
                </span>
                <span
                    v-if="redemption.status === 'cancelled'"
                    class="inline-flex align-text-bottom ml-1"
                    title="This redemption has been cancelled"
                >
                    <Icon
                        icon="x-circle"
                        :width="20"
                        :height="20"
                        class="text-red-500"
                        pathClass="fill-red-500"
                    />
                </span>
                <span
                    v-if="redemption.is_modified"
                    class="inline-flex align-text-bottom ml-1"
                    title="This redemption has been modified"
                >
                    <Icon
                        icon="edit"
                        :width="20"
                        :height="20"
                        class="text-blue-500"
                        pathClass="fill-blue-500"
                    />
                </span>
            </a>

            <a
                href="#"
                role="button"
                :class="
                    redemption.status === 'cancelled'
                        ? 'text-slate-400 text-sm font-medium line-through'
                        : 'text-slate-800 dark:text-slate-100 text-sm font-medium'
                "
                v-if="
                    redemption.date_type === 'start' &&
                    redemption.redemption_type.slug === 'flight'
                "
                @click.prevent="emit('viewRedemption', redemption)"
            >
                <span
                    class="bg-slate-200 dark:bg-slate-700 text-slate-600 dark:text-slate-300 px-1.5 py-0.5 text-xs rounded"
                    v-if="
                        redemption.travel_segments[0]?.travel_number &&
                        !sensitiveDataHidden
                    "
                >
                    {{ redemption.travel_segments[0]?.travel_number }}
                </span>
                {{ endLabel }} {{ cardTitle }}
                <span
                    v-if="redemption.source === 'email_import'"
                    class="inline-flex align-text-bottom ml-1"
                >
                    <Icon
                        icon="email-forward"
                        :width="20"
                        :height="20"
                        class="text-[#64748B] dark:text-slate-400"
                        pathClass="fill-[#64748B]"
                    />
                </span>
                <span
                    v-if="redemption.status === 'cancelled'"
                    class="inline-flex align-text-bottom ml-1"
                    title="This redemption has been cancelled"
                >
                    <Icon
                        icon="x-circle"
                        :width="20"
                        :height="20"
                        class="text-red-500"
                        pathClass="fill-red-500"
                    />
                </span>
                <span
                    v-if="redemption.is_modified"
                    class="inline-flex align-text-bottom ml-1"
                    title="This redemption has been modified"
                >
                    <Icon
                        icon="edit"
                        :width="20"
                        :height="20"
                        class="text-blue-500"
                        pathClass="fill-blue-500"
                    />
                </span>
            </a>

            <a
                :class="
                    redemption.status === 'cancelled'
                        ? 'text-slate-400 text-sm font-medium line-through'
                        : 'text-slate-800 dark:text-slate-100 text-sm font-medium'
                "
                href="#"
                role="button"
                @click.prevent="emit('viewRedemption', redemption)"
                v-if="
                    redemption.date_type === 'start' &&
                    redemption.redemption_type.slug === 'train'
                "
            >
                <span
                    class="bg-slate-200 dark:bg-slate-700 text-slate-600 dark:text-slate-300 px-1.5 py-0.5 text-xs rounded"
                    v-if="
                        redemption.travel_segments[0]?.travel_number &&
                        !sensitiveDataHidden
                    "
                >
                    {{ redemption.travel_segments[0]?.travel_number }}
                </span>
                {{ endLabel }} {{ cardTitle }}
                <span
                    v-if="redemption.source === 'email_import'"
                    class="inline-flex align-text-bottom ml-1"
                >
                    <Icon
                        icon="email-forward"
                        :width="20"
                        :height="20"
                        class="text-[#64748B] dark:text-slate-400"
                        pathClass="fill-[#64748B]"
                    />
                </span>
                <span
                    v-if="redemption.status === 'cancelled'"
                    class="inline-flex align-text-bottom ml-1"
                    title="This redemption has been cancelled"
                >
                    <Icon
                        icon="x-circle"
                        :width="20"
                        :height="20"
                        class="text-red-500"
                        pathClass="fill-red-500"
                    />
                </span>
                <span
                    v-if="redemption.is_modified"
                    class="inline-flex align-text-bottom ml-1"
                    title="This redemption has been modified"
                >
                    <Icon
                        icon="edit"
                        :width="20"
                        :height="20"
                        class="text-blue-500"
                        pathClass="fill-blue-500"
                    />
                </span>
            </a>

            <a
                :class="
                    redemption.status === 'cancelled'
                        ? 'text-slate-400 text-sm font-medium line-through'
                        : 'text-slate-800 dark:text-slate-100 text-sm font-medium'
                "
                href="#"
                role="button"
                @click.prevent="emit('viewRedemption', redemption)"
                v-if="
                    redemption.date_type === 'start' &&
                    redemption.redemption_type.slug === 'rental-car'
                "
            >
                {{ endLabel }} {{ redemption.pickup_location || '' }}
                <span
                    v-if="redemption.source === 'email_import'"
                    class="inline-flex align-text-bottom ml-1"
                >
                    <Icon
                        icon="email-forward"
                        :width="20"
                        :height="20"
                        class="text-[#64748B] dark:text-slate-400"
                        pathClass="fill-[#64748B]"
                    />
                </span>
                <span
                    v-if="redemption.status === 'cancelled'"
                    class="inline-flex align-text-bottom ml-1"
                    title="This redemption has been cancelled"
                >
                    <Icon
                        icon="x-circle"
                        :width="20"
                        :height="20"
                        class="text-red-500"
                        pathClass="fill-red-500"
                    />
                </span>
                <span
                    v-if="redemption.is_modified"
                    class="inline-flex align-text-bottom ml-1"
                    title="This redemption has been modified"
                >
                    <Icon
                        icon="edit"
                        :width="20"
                        :height="20"
                        class="text-blue-500"
                        pathClass="fill-blue-500"
                    />
                </span>
            </a>

            <p
                class="text-slate-500 dark:text-slate-400 text-sm flex flex-col gap-1 sm:flex-row sm:items-center"
            >
                <span v-if="redemption.date_type === 'end'">
                    {{ endLabel }}
                    <span
                        v-if="endBadge"
                        class="bg-slate-200 dark:bg-slate-700 text-slate-500 dark:text-slate-400 px-1.5 py-0.5 text-xs rounded"
                    >
                        {{ endBadge }}
                    </span>
                    {{ endName }}
                </span>
                <a
                    class="flex items-center gap-1"
                    href="#"
                    role="button"
                    @click.prevent="emit('viewRedemption', redemption)"
                    v-if="!sensitiveDataHidden"
                >
                    <span
                        v-if="
                            redemption.date_type === 'start' &&
                            redemption.start_date
                        "
                    >
                        {{
                            redemption.end_date
                                ? dayjs(redemption.start_date).format('MMM D')
                                : dayjs(redemption.start_date).format(
                                      'MMM D, YYYY'
                                  )
                        }}
                    </span>
                    <span
                        v-if="
                            redemption.date_type === 'start' &&
                            redemption.end_date
                        "
                    >
                        -
                    </span>
                    <span
                        v-if="
                            redemption.date_type === 'start' &&
                            redemption.end_date
                        "
                    >
                        {{ dayjs(redemption.end_date).format('MMM D, YYYY') }}
                    </span>
                    <span
                        class="px-1 text-slate-500 dark:text-slate-400"
                        v-if="
                            redemption.date_type === 'start' &&
                            ['flight', 'train', 'other'].includes(
                                redemption.redemption_type.slug
                            )
                        "
                    >
                        <div
                            class="hidden sm:block w-0.5 h-0.5 bg-slate-500 rounded-full"
                        ></div>
                    </span>
                </a>
                <span
                    v-if="
                        redemption.date_type === 'start' &&
                        ['flight', 'train', 'other'].includes(
                            redemption.redemption_type.slug
                        )
                    "
                >
                    {{ redemption.number_of_travelers }} traveler{{
                        redemption.number_of_travelers > 1 ? 's' : ''
                    }}
                </span>
            </p>
        </div>

        <div class="col-span-12 sm:col-span-4 md:col-span-4 lg:col-span-4">
            <!-- Component Statistics -->
            <RedemptionCardStats
                :redemption="redemption"
                v-if="redemption.date_type === 'start'"
            />
        </div>

        <div class="col-span-2 flex justify-end">
            <!-- Button and redemption actions -->
            <RedemptionActionsBtn
                :show-label="false"
                :show-border="false"
                :show-share="false"
                :redemption="redemption"
                v-if="redemption.date_type === 'start' && !readOnly"
                class="absolute -top-2 right-0 sm:relative sm:top-auto sm:right-auto"
            />

            <button
                type="button"
                @click="showRedemption()"
                class="cursor-pointer lg:px-2 rounded-full w-8 lg:w-10 min-h-10 lg:h-10 flex items-center justify-center hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 outline-none absolute bottom-2 right-2 sm:relative sm:bottom-auto sm:right-auto"
                v-if="redemption.date_type === 'start'"
            >
                <Icon icon="chevron-right" class="text-slate-400" />
            </button>
        </div>
    </div>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue';
import dayjs from 'dayjs';
import RedemptionCardStats from '@/components/trips/redemptions/redemption-card-stats.vue';
import RedemptionActionsBtn from '@/components/trips/redemptions/redemptions-more-actions-btn.vue';
import { useTripsStore } from '@/store/trips';
import { useTripTitles } from '@/composables/tripTitles';
import Icon from '@/components/ui/icon/icon.vue';

const props = defineProps({
    redemption: {
        type: Object,
        required: true,
    },
    readOnly: {
        type: Boolean,
        default: false,
    },
    trip: {
        type: Object,
        default: {},
    },
    hideSensitiveData: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['viewRedemption']);

const tripsStore = useTripsStore();

const redemptionRef = ref(props.redemption);
const { flightTitle, trainTitle, rentalTitle } = useTripTitles(redemptionRef);

onMounted(() => {});

const endLabel = computed(() => {
    const dateType = props.redemption.date_type;
    const type = props.redemption.redemption_type.slug;

    if (type === 'hotel') {
        if (dateType === 'start') {
            return 'Check-in';
        } else {
            return 'Check-out';
        }
    }

    if (type === 'flight') {
        if (dateType === 'start') {
            return 'Depart';
        } else {
            return 'Arrive';
        }
    }

    if (type === 'train') {
        if (dateType === 'start') {
            return 'Depart';
        } else {
            return 'Arrive';
        }
    }

    if (type === 'rental-car') {
        if (dateType === 'start') {
            return 'Pick up rental car';
        } else {
            return 'Drop off rental car';
        }
    }

    return '';
});

const endName = computed(() => {
    const type = props.redemption.redemption_type.slug;

    if (type === 'flight') {
        return flightTitle.value;
    }

    if (type === 'train') {
        return trainTitle.value;
    }

    if (type === 'rental-car') {
        return rentalTitle.value;
    }

    return props.redemption.name ? props.redemption.name : '';
});

// Travel number rendered as a badge alongside endName. Kept separate from the
// title text so both can be rendered as escaped text instead of via v-html,
// preventing stored XSS from user-controlled travel segment data.
const endBadge = computed(() => {
    const type = props.redemption.redemption_type.slug;
    const segments = props.redemption.travel_segments;

    if (!segments || !segments.length) {
        return '';
    }

    if (type === 'flight') {
        return segments[segments.length - 1]?.travel_number || '';
    }

    if (type === 'train') {
        return segments[0]?.travel_number || '';
    }

    return '';
});

const cardTitle = computed(() => {
    if (props.redemption.redemption_type?.slug === 'flight') {
        return flightTitle.value;
    }

    if (props.redemption.redemption_type?.slug === 'train') {
        return trainTitle.value;
    }

    if (props.redemption.redemption_type?.slug === 'rental-car') {
        return rentalTitle.value;
    }

    if (props.redemption.redemption_type?.slug === 'hotel') {
        return props.redemption.name || props.redemption.hotel?.name || '';
    }

    return (
        props.redemption.name || props.redemption.redemption_type?.name || ''
    );
});

const showRedemption = () => {
    tripsStore.setPanelRedemption(props.redemption);
    tripsStore.setActiveRedemption(props.redemption);
    tripsStore.setShowRedemptionPanel(true);
};

const sensitiveDataHidden = computed(() => {
    return props.readOnly && props.hideSensitiveData;
});
</script>
